@if (basket.qty) {
<!-- <progress-list [steps]="progressSteps"
  [current]="currentStep"
  (currentChange)="goToStep($event.name)"
  class="p-t-9 p-t-4-s w-12 inline-flex flex-justify-center">
</progress-list> -->
<checkout-navigation class="p-t-10 p-t-4-s w-12 inline-flex flex-justify-center overflow-hidden">
</checkout-navigation>
<checkout-basket-summary class="block m-t-10 m-t-3-s"></checkout-basket-summary>
@switch (customer.model.isLoggedIn) {
@case (true) {
<checkout-step [name]="stepNames.account"
               stepTitle="Email"
               [order]="10"
               class="block m-t m-t-2-s">
    <checkout-account></checkout-account>
</checkout-step>
}
@default {
<checkout-step [name]="accountStepName"
               stepTitle="Email"
               [order]="10"
               class="block m-t m-t-2-s">
    <checkout-account-alternative></checkout-account-alternative>
</checkout-step>
}
}
@if (!isVirtual) {
@if (displayDeliverySelection) {
<checkout-step [name]="deliverySelectionStepName"
               [stepGroup]="'delivery'"
               [hideInactive]="true"
               stepTitle="Delivery"
               [order]="30"
               class="block m-t m-t-2-s">
    <checkout-delivery-selection></checkout-delivery-selection>
</checkout-step>
}
<checkout-step [name]="deliveryStepName"
               [stepGroup]="'delivery'"
               stepTitle="Delivery"
               [order]="40"
               class="block m-t m-t-2-s">
    <checkout-delivery></checkout-delivery>
</checkout-step>
}
@if (!isFree) {
<checkout-step [name]="paymentStepName"
               stepTitle="Payment"
               [order]="50"
               class="block m-t m-t-2-s">
    <checkout-payment></checkout-payment>
</checkout-step>
}
<checkout-confirmation></checkout-confirmation>
<ng-container *ifSize="'XL'">
    @if (content.bottomImage || content.bottomCopy) {
    <div class="center m-t-10">
        <div [ngClass]="content.bottomImageRatio || 'ratio-1-1'"
             class="bottom-image inline-block">
            <img [image]="content.bottomImage"
                 [options]="{fitIn: true, fillColor: 'transparent'}"
                 class="rf">
        </div>
        <p *iCms="'bottomCopy' of content; skipEmpty: true"
           class="m-t-1 p1"
           text></p>
    </div>
    }
</ng-container>
}
